<!-- 媒体版位管理 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">媒体版位管理</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 ;">
		<div class="screen-box">
			<div class="screen-label">媒体版位</div>
			<a-input v-model="r_media_name" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<div class="screen-box">
			<div class="screen-label">媒体平台</div>
			<a-select
				show-search
				allowClear
			    style="min-width: 200px"
			    placeholder="请选择媒体平台"
			    @change="handleChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(item,index) in mdediaSelect" :key="item.id" :value="item.id">
			      {{item.platform_name}}
			    </a-select-option>
			</a-select>
			
		</div>
		
		<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
		
		<a-button class="screen-box" @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
	</div>
	

	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="item.id" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 媒体版位 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.media_name}}
			</div>
			<!-- 返点比率 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.discount}}
			</div>
			<!-- 显示/隐藏 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				<a-switch @change="switchStatus($event,item)" :loading="item.switch_status_loading" :checked="item.switch_status" checked-children="显示" un-checked-children="隐藏" />
			</div>
			<!-- 媒体平台 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.platform_name}}
			</div>
			<!-- 操作 -->
			<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_null_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		
	</div>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="600px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">媒体平台</div>
					
				<a-select :value="x_type" style="width: 240px" placeholder="未选择"
				 @change="handleChangeB" >
					<a-select-option  v-for="(item,index) in mdediaSelect" :key="item.id" :value="item.id">
						{{item.platform_name}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">媒体版位</div>
					
				<a-input v-model="x_media_name" placeholder="请输入" style="width: 240px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">返点比例</div>
					
				<a-input v-model="x_discount" placeholder="请输入" type="number" style="width: 240px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">显示/隐藏</div>
					
				<a-switch @change="switchStatusX" :checked="x_switch_status" checked-children="显示" un-checked-children="隐藏" />
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { mediaPlatformList, mediaPositionList, mediaPositionAdd, mediaPositionEdit } from '@/request/api'
export default {
	name: 'mediaPosition_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:120, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"媒体版位", width:200, type:"name", },
				{title:"返点比率", width:200, type:"name", },
				{title:"显示/隐藏", width:200, type:"status", },
				{title:"媒体平台", width:200, type:"name", },
				{title:"操作", width:200, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false,
			
			r_page: 1,
			table_total: 0,
			r_limit: 20,
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_media_name:"", // 新增/编辑的媒体版位名称
			x_id:"",
			x_type: undefined, // 媒体平台的id
			x_discount: "", // 返点比例
			x_switch_status: false,
			
			mdediaSelect: [],
			r_media_name: "", // 书籍名称
			r_type: "", // 媒体平台
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		mediaPlatformList({page: 1,limit:1000}).then(res=>{
			console.log("媒体平台列表",res.data.data);
			
			that.mdediaSelect = res.data.data.data
		})
		
		that.searchButton()
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		handleChangeA(value) {
			console.log(value)
			this.r_type = value // 记录选择的人的id
		},
		handleChangeB(value){
			console.log(value)
			this.x_type = value
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			mediaPositionList(
				{
				page: that.r_page,
				pageSize: that.r_limit,
				media_name: that.r_media_name,
				type: that.r_type
				}
			).then(res=>{
				console.log("列表",res.data.data);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					
					let data = res.data.data.data
					data.forEach(res=>{
						res.switch_status_loading = false
						if(res.status == 1){ // 显示
							res.switch_status = true
						}
						else { // 为2表示隐藏
							res.switch_status = false
						}
					})
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			this.drawer_title = "新增"
			this.visible = true
		},
		// 编辑
		editTable(index,e){
			console.log(e);
			let that = this
			this.drawer_title = "编辑"
			this.x_id = e.id
			this.x_media_name = e.media_name
			this.x_type = e.type
			this.x_discount = e.discount
			
			this.x_switch_status = e.switch_status
			
			this.visible = true
		},
		// 新增/编辑
		addRequest(){
			let that = this
			if(!that.x_type){
				that.add_form_hint = "请选择媒体平台"
			}
			else if(!that.x_media_name){
				that.add_form_hint = "请填写媒体版位"
			}
			else if(!that.x_discount){
				that.add_form_hint = "请填写返点比例"
			}
			else {
				that.add_button_loading = true
				if(that.drawer_title == "新增"){
					mediaPositionAdd({
						media_name: that.x_media_name,
						discount: that.x_discount,
						type: that.x_type,
						status: that.x_switch_status?1:2,
					}).then(res=>{
						console.log("新增",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					mediaPositionEdit({
						media_name: that.x_media_name,
						id: that.x_id,
						discount: that.x_discount,
						type: that.x_type,
						status: that.x_switch_status?1:2,
					}).then(res=>{
						console.log("编辑",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				
			}
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			
			this.x_media_name = ""
			this.x_id = ""
			this.x_type = undefined
			this.x_discount = ""
			this.add_form_hint = ""
			
			this.visible = false
			
			this.x_switch_status_loading = false
			this.x_switch_status = false
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton()
		},
		
		switchStatus(e,item){
			console.log("显示隐藏",e,item);
			let that = this
			item.switch_status_loading = true
			
			mediaPositionEdit({
				id: item.id,
				status: e?1:2,
			}).then(res=>{
				console.log("编辑",res);
				item.switch_status_loading = false
				if(res.data.code == 0){
					item.switch_status = !item.switch_status
					that.$message.success('操作成功');
				}
				else {
					that.$message.error(res.data.msg || "请求失败");
				}
			})
		},
		switchStatusX(e){
			this.x_switch_status = e
		}
	}
}	
</script>

<style scoped>

</style>